import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Icon } from '@tvd/design-system/icon';
import type { IconName } from '@tvd/design-system/icon';
import {
  type ThemePreference,
  ThemeService,
} from '@tvd/data-access/theme';

const OPTIONS: ReadonlyArray<{
  preference: ThemePreference;
  icon: IconName;
  labelKey: string;
}> = [
  {
    preference: 'light',
    icon: 'light_mode',
    labelKey: 'settings.themeOptions.light',
  },
  {
    preference: 'system',
    icon: 'desktop_windows',
    labelKey: 'settings.themeOptions.system',
  },
  {
    preference: 'dark',
    icon: 'dark_mode',
    labelKey: 'settings.themeOptions.dark',
  },
];

@Component({
  selector: 'tvd-theme-toggle',
  template: `
    <div
      role="group"
      class="inline-flex items-center gap-0.5 p-0.5 rounded-full bg-secondary/15"
      [attr.aria-label]="'settings.theme' | translate"
      [title]="'settings.theme' | translate"
    >
      @for (option of options; track option.preference) {
        <button
          type="button"
          class="flex items-center justify-center w-7 h-7 rounded-full cursor-pointer transition-[background-color,color,transform] duration-200 active:scale-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-800"
          [class]="{
            'bg-primary/50 text-primary-950 hover:bg-primary/65 active:bg-primary/75':
              preference() === option.preference,
            'text-secondary-600 hover:bg-secondary/25 hover:text-secondary-800 active:bg-secondary/40':
              preference() !== option.preference,
          }"
          [attr.aria-pressed]="preference() === option.preference"
          [attr.aria-label]="option.labelKey | translate"
          [title]="option.labelKey | translate"
          (click)="theming.setPreference(option.preference)"
        >
          <tvd-icon [icon]="option.icon" size="sm" />
        </button>
      }
    </div>
  `,
  imports: [Icon, TranslatePipe],
})
export class ThemeToggle {
  readonly theming = inject(ThemeService);
  readonly preference = this.theming.preference;
  readonly options = OPTIONS;
}
